import { render, staticRenderFns } from "./QuestionType.vue?vue&type=template&id=086113ee"
import script from "./QuestionType.vue?vue&type=script&lang=js"
export * from "./QuestionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports